import getMonetateExperience from '../../utils/monetate/getMonetateExperience';

const replaceCategoryChild = (category, content, columnName) => ({
  ...category,
  child: [...category.child.filter(({ name }) => name !== columnName), content],
});

const mergeContentBlocks = (features, rootCategories, contentConfigFile) => {
  const contentBlocksExperience = getMonetateExperience(
    features,
    'content-blocks'
  );
  const categoriesToReplace = contentBlocksExperience?.parameters?.categories?.split(
    ','
  );

  if (categoriesToReplace?.length > 0) {
    return {
      ...rootCategories,
      child: contentConfigFile?.length
        ? rootCategories.child.map(category => {
            const categoryParams = categoriesToReplace.find(
              c => c.trim().split('|')[0] === category.name
            );

            const content = contentConfigFile.find(
              c => c.category === category.name
            );

            return categoryParams && content
              ? replaceCategoryChild(
                  category,
                  content,
                  categoryParams.trim().split('|')[1]
                )
              : category;
          })
        : rootCategories.child,
    };
  }

  return rootCategories;
};

export default mergeContentBlocks;
